import { Injectable } from "@angular/core";
import { AsyncValidatorFn, FormArray, FormBuilder, Validators } from "@angular/forms";
import { PersonalInfoFieldTypeEnum } from "@modules/api/personal-info-field-type-enum.generated";
import { PIIField } from "@modules/api/pii-field.generated";
import { isValidPhoneNumber } from "@modules/common/validators/is-valid-phone-number";
import { LoginEnterPIIComponent } from "@modules/login-shared/components/login-enter-pii/login-enter-pii.component";
import { PIIQuestionFormGroup } from "@modules/login-shared/types/pii-question-form-group.type";

@Injectable({
    providedIn: 'root'
})
export class BuildPIIQuestionsFormArrayService {
    constructor(private readonly _formBuilder: FormBuilder) {
    }

    /**
     * Builds the {@link FormArray} to be used with {@link LoginEnterPIIComponent}.
     */
    public buildPIIQuestionsFormArray(piiFields: PIIField[]): FormArray<PIIQuestionFormGroup> {
        return this._formBuilder.array(piiFields.map(field => this.buildPIIQuestionFormGroup(field)));
    }

    private buildPIIQuestionFormGroup(field: PIIField): PIIQuestionFormGroup {
        return this._formBuilder.nonNullable.group({
            piiField: [field],
            answer: ['', Validators.required, this.getAnswerAsyncValidators(field)],
        });
    }

    private getAnswerAsyncValidators(field: PIIField): AsyncValidatorFn[] {
        return field.personalInfoFieldType == PersonalInfoFieldTypeEnum.PhoneNumber ? [isValidPhoneNumber] : [];
    }
}